module.exports = __webpack_public_path__ + "img/stop_btn.b6492dd7.png";